import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_legacy_plan_picker_tai_chi_yoga_walking~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__b'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_legacy_plan_picker_tai_chi_yoga_walking~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__b'
					),
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_legacy_plan_picker_tai_chi_yoga_walking~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__b'
					),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_legacy_plan_picker_tai_chi_yoga_walking~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__c'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_legacy_plan_picker_tai_chi_yoga_walking~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__c'
					),
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_legacy_plan_picker_tai_chi_yoga_walking~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_legacy_plan_picker_tai_chi_yoga_walking__c'
					),
			},
		},
	},
]

export default config
